import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import AppMenu from '@/components/menu/AppMenu.vue'
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import ToastContainer from './components/shared/toastContainer.vue';
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const showMenu = computed(() => !route.meta.hideMenu)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showMenu.value)
      ? (_openBlock(), _createBlock(AppMenu, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    _createVNode(ToastContainer)
  ], 64))
}
}

})